import { MobileBadge } from "@faire/deprecated-retailer-visitor-shared/icons/AppDownloadBadge/__internal__/MobileBadge";
import { isLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import { Core } from "@faire/slate/foundation/color";
import { trackRetailerMobileFooterDesktopappStoreBadgeHover } from "@faire/web-api--source/events/retailerMobile/actionCategoryOther/footerDesktopAppStoreBadgeHover";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { useStrictLocalization } from "@faire/web/common/localization";
import { useLocalization } from "@faire/web/common/localization/useLocalization";
import React, { FC } from "react";

const APP_STORE_QR_IMAGE_URL =
  "https://cdn.faire.com/fastly/3d77d319b263789c7bf9e0d352daa4d5f80ace5d3a1d46f1d532d4c6b7a13c71.png";

const getBadge = (locale: string): string => {
  if (SUPPORTED_LOCALES.includes(locale)) {
    return `https://cdn.faire.com/static/download-badges/app-store-${locale}.svg`;
  } else {
    return "https://cdn.faire.com/static/download-badges/app-store-en.svg";
  }
};

const useBadgeWidth = () =>
  useViewport().isDesktopAndAbove && !isLoggedInRetailer() ? 142 : 120;

export const AppStoreBadge: FC = () => {
  const badgeWidth = useBadgeWidth();
  return (
    <MobileBadge
      backgroundColor={Core.surface.primaryInverse}
      badge={<AppStoreImage />}
      qrCodeUrl={APP_STORE_QR_IMAGE_URL}
      qrCodeContainerWidth={badgeWidth}
      qrCodePadding={11}
      trackingFunctionOnHover={
        useViewport().isTabletAndAbove && !isLoggedInRetailer()
          ? trackRetailerMobileFooterDesktopappStoreBadgeHover
          : undefined
      }
    />
  );
};

export const AppStoreImage: FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const badgeWidth = useBadgeWidth();
  const {
    intl: { locale },
  } = useLocalization();
  return (
    <img
      width={badgeWidth}
      src={getBadge(locale)}
      alt={strictLocalize({
        id: "KO8JIn",
        defaultMessage: "Apple App Store Badge",
        description: {
          text: "Alt text for the badge to download app on Apple App Store. This will only be shown if the badge does not render.",
          img: "https://cdn.faire.com/static/download-badges/app-store-en.svg",
        },
      })}
      style={{ display: "block" }}
    />
  );
};

const SUPPORTED_LOCALES = [
  "ar-AR",
  "az-TR",
  "bg-BG",
  "cs-CZ",
  "da-DK",
  "de-DE",
  "el-GR",
  "en",
  "es-ES",
  "es-MX",
  "et-EE",
  "fi-FI",
  "fr-CA",
  "fr-FR",
  "hb-HB",
  "hu-HU",
  "id-ID",
  "it-IT",
  "ja-JP",
  "ko-KR",
  "lt-LT",
  "lv-LV",
  "ms-MY",
  "mt-MT",
  "nl-NL",
  "no-NO",
  "pl-PL",
  "pt-BR",
  "pt-PT",
  "ro-RO",
  "ru-RU",
  "sk-SK",
  "sl-SI",
  "sv-SE",
  "th-TH",
  "tl-PH",
  "tr-TR",
  "vi-VN",
  "zh-CN",
  "zh-HK",
];
